import React from 'react'
import styled from 'styled-components'
import { formatNavCount, formatRailCount } from 'features/taskManagement/taskViewCounts'

export const CountFull = styled.b`
  font-weight: inherit;
`

export const CountShort = styled.b`
  font-weight: inherit;
  display: none;
`

const NavCountText = ({ value }) => (
  <>
    <CountFull data-count='full'>{formatNavCount(value)}</CountFull>
    <CountShort data-count='rail'>{formatRailCount(value)}</CountShort>
  </>
)

export default NavCountText
